import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {Grid, Box} from '@mui/material';
import FieldView2 from 'core/components/layout/FieldView2';


export default function WorkerInfo(){
  const { workerObj} = useSelector((state)=>state.manufslice.workerDashboard);
    return (
      <Box lg={12} sx={{ flexGrow: 1 }}>
      <Grid item sx={{ overflowY: "scroll", backgroundColor: 'white', maxHeight: { xs: window.screen.height - 250, lg: window.screen.height } }}>
        
        <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        sx={{backgroundColor:'white'}}
      >
            
        <Grid item lg={4} xs={6}><FieldView2 label="Business Id"  value={ workerObj.businessid!==null && workerObj.businessid!==undefined?workerObj.businessid:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Title"  value={ workerObj.title!==null && workerObj.title!==undefined?workerObj.title:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Skill  Id"  value={ workerObj.skillid!==null && workerObj.skillid!==undefined?workerObj.skillid:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Skill  Name"  value={ workerObj.skillname!==null && workerObj.skillname!==undefined?workerObj.skillname:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Experience Level Id"  value={ workerObj.experiencelevelid!==null && workerObj.experiencelevelid!==undefined?workerObj.experiencelevelid:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Experience Level Name"  value={ workerObj.experiencelevelname!==null && workerObj.experiencelevelname!==undefined?workerObj.experiencelevelname:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Type Id"  value={ workerObj.typeid!==null && workerObj.typeid!==undefined?workerObj.typeid:'NOT KNONWN' }/></Grid>
      </Grid>
      </Grid>
      </Box>
    )
}